const constant = {
  regularize_type: "regularize",
  tag_meeting: "tagMeeting",
  backendDateFormat: "YYYY-MM-DD",
  meetingTypeNew: "New",
  userRoles: {
    ADMIN: "admin",
  },
  cache_expiry_minutes: 60,
  allowedImdFileType: "text/csv",
};

export default constant;
